export default __webpack_public_path__ + "static/jordan-t-a997e0efafbad75f5daa060e3792f570.jpg";